// header script start
  // mega menu script
      window.addEventListener("resize", function(e) {
            e.preventDefault();
            "use strict"; 
          });
      document.addEventListener("DOMContentLoaded", function()
      {
      document.querySelectorAll('.dropdown-menu').forEach(function(element)
      {
              element.addEventListener('click', function(e)
              {
                      e.stopPropagation();
              });
      })         
      if (window.innerWidth < 992)
      {
              document.querySelectorAll('.navbar .dropdown').forEach(function(everydropdown)
              {
                      everydropdown.addEventListener('hidden.bs.dropdown', function()
                      {
                              this.querySelectorAll('.submenu')
                                      .forEach(function(everysubmenu)
                                      {
                                              everysubmenu
                                                      .style
                                                      .display =
                                                      'none';
                                      });
                      })
              });
              document.querySelectorAll('.dropdown-menu a').forEach(function(element)
              {
                      element.addEventListener('click', function(e)
                      {
                              let nextEl = this.nextElementSibling;
                              if (nextEl && nextEl.classList
                                      .contains('submenu'))
                              {
                                      e.preventDefault();
                                      console.log(nextEl);
                                      if (nextEl.style.display ==
                                              'block')
                                      {
                                              nextEl.style.display =
                                                      'none';
                                      }
                                      else
                                      {
                                              nextEl.style.display =
                                                      'block';
                                      }
                              }
                      });
              })
      }
      });
      
      // header sticky

    //   $(window).scroll(function(){
    //   if ($(window).scrollTop() >= 330) {
    //     $('header').addClass('fixed');
    //   }
    //   else {
    //     $('header').removeClass('fixed');
    //   }
    // });

    
    $(".mnavbar figure").click(function(){
      $(".mnavbar").toggleClass("menu-open");
      $("body").addClass("mshow");
    });
    
      
      
      //clear search bar on click close icon
  $(document).ready(function () {
      $('.searchbar button[type="reset"]').css("opacity","0");
      $(document).on("input", ".searchbar input.search", function() {
      $('.searchbar button[type="reset"]').css("opacity","1");
      // do something
      });
      $('.searchbar button[type="reset"]').on("click", function(){
        var search_value = $('.searchbar').find('input.search').val();
        var url = window.location.href;
        // console.log(search_value);
        if(url.includes('/search?')){
          var suburl = url.replace(search_value,"");
        $('.searchbar').find('input.search').val('');
        $('.searchbar button[type="reset"]').css("opacity","0");
          // console.log(suburl);
          return false;
          // window.location.href = suburl;
        }
        $('.searchbar').find('input.search').val('');
        $('.searchbar button[type="reset"]').css("opacity","0");
      });
        $('html').keyup(function(e){
         if(e.keyCode == 8){ 
             // console.log($('.search').val());
             if($('.searchbar input.search').val() == ''){
                 $('.searchbar button[type="reset"]').css("opacity","0");
             }
         }
       });
    });



      $("body").on("click", function(e){
        // e.preventDefault();
        if( 
          $(e.target).closest(".mnavbar").length == 0 &&
          $(".mnavbar").hasClass("menu-open") &&
          $(e.target).closest(".menu-btn").length == 0
        ){
          $("body ").toggleClass("mshow");
          $('.mnavbar').toggleClass('menu-open');
        }
      });

 
      $(".mnavbar-title figure").click(function(){
        $(".mnavbar ").removeClass(".menu-open");
        $("body ").toggleClass("mshow");
      });
 

// header script End